// extracted by mini-css-extract-plugin
export default {"div":"main_div__2DZFs"};